import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-50">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:grid-cols-3 md:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-movie-2-fill text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold">出轨的味道</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-50/60">
            专注于“出轨的味道”相关影视剧的内容门户，提供全集查询、详细剧情介绍、演员资料与相关资讯，为影视剧爱好者提供一站式了解入口。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6">
          <div>
            <p className="font-label text-xs tracking-[0.25em] text-background-50/40">导航</p>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li><Link to="/" className="text-background-50/75 transition-colors hover:text-accent-400 cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-background-50/75 transition-colors hover:text-accent-400 cursor-pointer">影视分类</Link></li>
              <li><Link to="/news" className="text-background-50/75 transition-colors hover:text-accent-400 cursor-pointer">资讯专题</Link></li>
              <li><Link to="/about" className="text-background-50/75 transition-colors hover:text-accent-400 cursor-pointer">关于我们</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-label text-xs tracking-[0.25em] text-background-50/40">联系</p>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-50/75">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>hello@chuguiweidao.site</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>微信公众号：出轨的味道</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-4 py-6 text-xs text-background-50/45 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>© {year} 出轨的味道 CHUGUIWEIDAO.SITE · 保留所有权利</p>
          <p>本站为影视内容展示与资讯平台，所有内容仅供观众了解与交流参考。</p>
        </div>
      </div>
    </footer>
  );
}